<template>
  <div class="c-container">
    <div class="flex flex-col items-center">
      <svg class="mb-8" width="248" height="247" viewBox="0 0 248 247" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M244.353 105.337C237.631 61.3393 210.07 7.28449 155.623 1.62729C155.623 1.62729 114.284 -3.40104 73.5322 4.22029C49.3461 8.74305 28.1389 22.2074 14.7195 41.558C1.30001 60.9094 -3.18224 84.5053 2.25741 107.001C5.79107 121.612 8.17796 136.734 7.52267 151.748C6.69651 170.683 5.14018 190.592 13.511 208.249C25.7758 234.12 55.7 241.74 81.8114 244.17C91.4339 245.066 101.092 245.427 110.722 246.188C129.197 247.648 149.915 245.285 167.722 240.475C258.469 215.962 251.075 149.335 244.353 105.337Z"
          fill="#2C2444"
        />
        <path
          opacity="0.3"
          d="M137.928 149.416L134.52 142.162C137.394 139.991 140.056 137.596 142.467 134.989L148.894 139.535C150.646 140.775 153.026 140.302 154.212 138.48L161.637 127.066C162.826 125.238 162.371 122.742 160.619 121.493L154.129 116.864C155.555 113.511 156.704 110.03 157.559 106.459L165.409 107.093C167.525 107.264 169.368 105.602 169.526 103.379L170.518 89.4385C170.678 87.2031 169.085 85.246 166.962 85.0699L159.071 84.4146C158.713 80.7585 158.036 77.0989 157.056 73.4701L164.224 69.8589C166.149 68.8892 166.957 66.4477 166.027 64.4043L160.198 51.5812C159.262 49.5237 156.936 48.6438 155.003 49.6179L147.802 53.2458C145.696 50.1393 143.37 47.2557 140.84 44.631L145.314 37.6544C146.521 35.7722 146.05 33.1862 144.26 31.8783L133.032 23.673C131.232 22.3571 128.791 22.8239 127.583 24.7167L123.113 31.7233C119.831 30.1255 116.424 28.8308 112.935 27.8479L113.448 19.3422C113.587 17.0381 111.936 15.0088 109.761 14.8133L96.1302 13.5855C93.9467 13.3891 92.0698 15.104 91.9394 17.4142L91.4621 25.8564C87.8958 26.1894 84.3357 26.8737 80.8153 27.8866L77.2138 20.223C76.2273 18.1233 73.8387 17.2205 71.879 18.2069L59.6274 24.3794C57.6686 25.3667 56.8882 27.8664 57.8835 29.9617L61.4894 37.5478C58.5229 39.7814 55.7881 42.2573 53.3158 44.9525L46.6774 40.2174C44.8331 38.9016 42.3687 39.3737 41.1752 41.2717L33.7248 53.1207C32.5358 55.0126 33.0686 57.6039 34.913 58.9083L41.5223 63.5843C40.091 67.0634 38.9628 70.6737 38.1436 74.3703L30.3171 73.7203C28.1292 73.5388 26.2708 75.2369 26.1678 77.512L25.523 91.6986C25.42 93.9604 27.1049 95.936 29.2839 96.1112L37.0215 96.7357C37.4663 100.473 38.2484 104.203 39.3415 107.889L32.4547 111.358C30.5214 112.332 29.7613 114.767 30.7566 116.794L36.959 129.43C37.9472 131.443 40.3086 132.289 42.2331 131.319L49.0881 127.866C51.2927 130.948 53.7122 133.797 56.3325 136.372L52.162 142.908C50.9897 144.745 51.5041 147.244 53.3088 148.491L64.5615 156.262C66.3557 157.501 68.7593 157.024 69.9307 155.197L74.1311 148.648C77.427 150.158 80.8347 151.372 84.3181 152.268L83.8725 160.16C83.7483 162.355 85.3733 164.26 87.5012 164.418L100.784 165.399C102.905 165.556 104.73 163.909 104.862 161.72L105.339 153.812C108.825 153.435 112.304 152.725 115.741 151.695L119.153 158.874C120.091 160.849 122.391 161.672 124.29 160.715L136.169 154.73C138.071 153.773 138.857 151.395 137.928 149.416ZM145.147 67.1814C157.753 94.4193 147.123 126.775 121.512 139.679C95.9003 152.582 64.6566 141.322 51.6168 114.303C38.4563 87.0305 48.8115 54.0966 74.8586 40.9731C100.906 27.8514 132.423 39.689 145.147 67.1814Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M87.6798 127.781C85.5157 128.727 82.5862 130.027 78.6377 129.909C76.1231 129.833 74.75 129.792 73.8507 128.934C70.8561 126.075 76.0668 116.705 86.6096 98.0789C89.9812 92.1223 92.1981 88.5357 96.646 86.8517C101.695 84.9396 106.552 86.643 108.336 87.2683C109.594 87.7096 119.815 91.4775 121.722 101.186C123.281 109.12 118.66 117.83 110.197 121.93C109.695 121.221 109.192 120.512 108.69 119.802C109.464 118.556 110.952 115.776 110.995 112.001C111.04 107.955 109.421 103.167 108.07 103.225C105.915 103.318 108.454 115.552 101.067 122.108C99.8705 123.169 100.617 122.126 87.6798 127.781Z"
          fill="url(#paint1_linear)"
        />
        <path
          opacity="0.3"
          d="M117.91 107.036C117.445 103.797 116.001 93.7217 109.754 91.2564C104.856 89.3231 100.01 93.2549 97.6967 90.8134C96.7604 89.8252 96.6838 88.2627 96.9075 86.7574C96.8203 86.7883 96.7322 86.8182 96.645 86.8517C92.1971 88.5357 89.9802 92.1222 86.6086 98.0789C76.0658 116.705 70.8551 126.075 73.8498 128.934C74.749 129.793 76.1222 129.833 78.6368 129.909C82.5861 130.028 85.5156 128.727 87.6788 127.781C100.616 122.127 99.8695 123.169 101.065 122.107C108.452 115.551 105.913 103.317 108.068 103.224C109.42 103.166 111.039 107.955 110.993 112C110.951 115.775 109.462 118.555 108.688 119.801C109.19 120.51 109.693 121.219 110.195 121.929C113.332 120.409 115.94 118.255 117.902 115.741C118.269 113.174 118.368 110.231 117.91 107.036Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M111.266 184.489L189.153 172.538L201.968 124.269L117.815 130.357L111.266 184.489Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M117.816 130.357L111.267 184.391L110.258 184.194L62.3874 174.77L53.4062 127.257L52.876 124.449L117.816 130.357Z"
          fill="#D8DEE8"
        />
        <path d="M52.8779 122.796L135.952 116.399L201.969 121.498L118.381 128.533L52.8779 122.796Z" fill="white" />
        <path
          d="M118.381 128.533L52.8779 122.796V125.567L118.381 131.303L201.969 124.269V121.498L118.381 128.533Z"
          fill="#B7C0CE"
        />
        <path
          opacity="0.4"
          d="M110.258 184.194L62.3885 174.77L53.4072 127.257C55.7791 128.783 59.0961 130.386 63.4427 131.304C73.5901 133.445 84.9503 144.048 84.3444 156.165C83.7384 168.282 93.5837 157.074 103.58 172.977C106.632 177.835 108.768 181.477 110.258 184.194Z"
          fill="#D8DEE8"
        />
        <path
          d="M84.8864 120.162L86.3132 119.572C86.3132 119.572 78.3352 111.497 93.2986 95.0279C93.2986 95.0279 100.67 85.5842 97.0023 86.4042C92.2514 87.4664 84.483 89.7371 77.3144 99.5216C70.1466 109.304 74.2581 117.867 84.8864 120.162Z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M106.113 87.0931C105.586 86.6791 105.476 85.9234 105.864 85.3765L107.006 83.7655L105.815 81.5636L101.623 84.7009C100.511 85.5341 99.2116 86.0837 97.8394 86.3021L97.1436 86.4131C97.1436 86.4131 101.181 88.6036 103.251 89.3091C105.321 90.0146 107.781 88.4019 107.781 88.4019L106.113 87.0931Z"
          fill="url(#paint5_linear)"
        />
        <path
          d="M110.944 77.2425L111.217 77.187C112.337 76.9589 113.494 78 113.802 79.5114L113.819 79.5959C114.127 81.1073 113.468 82.5174 112.347 82.7456L112.075 82.801C111.51 82.9155 110.799 81.7644 110.487 80.2292C110.175 78.6949 110.379 77.3579 110.944 77.2425Z"
          fill="url(#paint6_linear)"
        />
        <path
          d="M109.847 80.3604C110.189 82.0409 111.121 83.2696 111.955 83.0996C112.79 82.9296 113.211 81.4252 112.87 79.7456C112.528 78.0651 111.552 76.8452 110.718 77.0152C109.883 77.1843 109.505 78.6799 109.847 80.3604Z"
          fill="url(#paint7_linear)"
        />
        <path
          d="M112 83.0907L111.681 83.1559L110.443 77.0707L110.762 77.0055L112 83.0907Z"
          fill="url(#paint8_linear)"
        />
        <path
          d="M109.551 80.4208C109.893 82.1013 110.846 83.3255 111.681 83.1556C112.516 82.9856 112.915 81.4865 112.573 79.806C112.231 78.1255 111.277 76.9012 110.443 77.0712C109.609 77.2412 109.209 78.7402 109.551 80.4208Z"
          fill="url(#paint9_linear)"
        />
        <path
          opacity="0.6"
          d="M110.24 80.2802C110.426 81.1936 110.945 81.8594 111.398 81.7669C111.852 81.6745 112.07 80.8589 111.884 79.9455C111.698 79.0322 111.179 78.3663 110.726 78.4588C110.272 78.5513 110.054 79.3668 110.24 80.2802Z"
          fill="url(#paint10_linear)"
        />
        <path
          d="M107.604 83.975C107.202 84.0878 106.344 84.2947 105.211 84.2771C104.168 84.2613 102.267 84.2137 101.032 82.8829C100.824 82.6574 100.321 82.1025 100.174 81.2323C100.131 80.9822 99.9764 80.0706 100.484 79.3704C101.032 78.6155 101.723 78.9705 102.39 78.3064C103.338 77.3613 102.577 76.004 103.365 75.4694C104.059 74.9982 104.762 75.9767 106.29 75.6464C107.121 75.4668 107.118 75.1338 108.24 74.8485C108.985 74.6591 109.923 74.4213 110.421 74.8766C110.902 75.317 110.46 75.9336 110.929 76.8135C111.4 77.6986 112.086 77.5234 112.432 78.184C113.073 79.4073 111.599 81.6868 110.019 82.8468C109.047 83.5619 108.023 83.8579 107.604 83.975Z"
          fill="url(#paint11_linear)"
        />
        <path
          d="M105.193 84.0781C105.193 84.0781 106.51 86.0608 109.182 85.7824C111.57 85.534 111.98 80.5603 110.471 79.5721C109.967 79.2418 108.951 79.1379 108.119 79.3871C107.628 79.5342 107.459 79.7298 106.652 79.9561C105.907 80.1657 105.698 80.0979 105.471 80.282C105.187 80.5128 104.975 81.0571 105.425 82.4901C104.973 82.0814 104.427 81.9405 104.036 82.1263C103.973 82.1563 103.808 82.2664 103.713 82.4276C103.371 83.0106 103.922 83.7117 105.193 84.0781Z"
          fill="url(#paint12_linear)"
        />
        <path
          d="M104.252 79.5712L103.905 79.6382L103.695 78.5671C103.334 76.7202 104.307 74.9507 105.91 74.5385L107.627 74.0972C108.525 73.8665 109.46 74.0594 110.261 74.6389C111.061 75.2185 111.619 76.1063 111.828 77.1385L111.944 77.704L111.537 77.4732L111.483 77.2081C111.295 76.2842 110.797 75.4897 110.08 74.9709C109.363 74.4522 108.525 74.2804 107.723 74.4865L106.006 74.9278C104.585 75.2933 103.723 76.862 104.043 78.4993L104.252 79.5712Z"
          fill="url(#paint13_linear)"
        />
        <path
          d="M110.473 75.5373C110.332 75.5663 110.179 75.5293 110.05 75.4227C109.396 74.8793 108.582 74.6803 107.817 74.8767L106.101 75.3179C105.501 75.4721 104.995 75.8772 104.675 76.4594C104.523 76.7342 104.197 76.8082 103.944 76.6241C103.691 76.44 103.609 76.0675 103.761 75.7927C104.221 74.9542 104.951 74.3711 105.814 74.1492L107.53 73.7079C108.6 73.4331 109.738 73.7114 110.654 74.4715C110.896 74.6732 110.957 75.0493 110.79 75.3118C110.713 75.4351 110.598 75.5117 110.473 75.5373Z"
          fill="url(#paint14_linear)"
        />
        <path
          opacity="0.3"
          d="M109.497 74.4865C108.135 74.3235 108.05 73.9378 107.377 74.0435C106.119 74.2416 105.887 75.6773 104.637 75.7477C104.344 75.7645 104.079 75.7011 103.863 75.6183C103.828 75.6746 103.793 75.7328 103.761 75.7918C103.609 76.0666 103.691 76.4391 103.944 76.6232C104.197 76.8073 104.523 76.7342 104.675 76.4585C104.995 75.8763 105.501 75.4712 106.101 75.317L107.817 74.8758C108.582 74.6794 109.396 74.8784 110.05 75.4219C110.179 75.5284 110.332 75.5645 110.473 75.5364C110.598 75.5108 110.713 75.4342 110.792 75.3109C110.943 75.0722 110.907 74.741 110.719 74.5314C110.368 74.5472 109.956 74.5411 109.497 74.4865Z"
          fill="url(#paint15_linear)"
        />
        <path
          d="M106.044 81.0817C106.389 82.7807 105.985 84.2965 105.141 84.4683C104.297 84.64 103.333 83.4017 102.988 81.7026C102.642 80.0036 103.047 78.4878 103.89 78.3161C104.734 78.1443 105.699 79.3827 106.044 81.0817Z"
          fill="url(#paint16_linear)"
        />
        <path
          d="M105.743 81.1425C106.088 82.8415 105.684 84.3573 104.84 84.529C103.997 84.7008 103.032 83.4624 102.687 81.7634C102.342 80.0644 102.746 78.5486 103.59 78.3769C104.433 78.206 105.398 79.4435 105.743 81.1425Z"
          fill="url(#paint17_linear)"
        />
        <path
          d="M103.294 78.7142L103.019 78.7705C101.886 79.0004 101.221 80.4264 101.531 81.9545L101.549 82.04C101.86 83.5681 103.03 84.6206 104.162 84.3908L104.437 84.3344C105.009 84.2181 105.216 82.8661 104.9 81.3133C104.584 79.7623 103.865 78.5979 103.294 78.7142Z"
          fill="url(#paint18_linear)"
        />
        <path
          d="M103.551 81.5432C103.779 82.6636 103.511 83.6641 102.953 83.7769C102.396 83.8905 101.758 83.074 101.531 81.9537C101.303 80.8333 101.57 79.8328 102.129 79.72C102.686 79.6064 103.324 80.4229 103.551 81.5432Z"
          fill="url(#paint19_linear)"
        />
        <path
          d="M87.6748 121.14L87.9778 122.086L100.084 124.449L131.295 119.739V118.754L87.6748 121.14Z"
          fill="url(#paint20_linear)"
        />
        <path
          d="M87.6748 121.14L99.9431 123.422L131.316 118.83L125.919 117.089L87.6748 121.14Z"
          fill="url(#paint21_linear)"
        />
        <path
          d="M110.64 119.948L110.443 89.6472C110.44 89.139 110.876 88.7735 111.492 88.7656L151.038 88.238C151.353 88.2336 151.954 88.5004 152.192 88.7277C152.43 88.9549 152.698 88.9981 152.687 89.2887L151.325 114.307C151.304 114.703 150.981 115.021 150.537 115.085L111.614 120.635L110.64 119.948Z"
          fill="url(#paint22_linear)"
        />
        <path
          d="M111.615 120.635L111.55 90.2629C111.549 89.7582 111.981 89.3953 112.593 89.3856L151.868 88.792C152.181 88.7876 152.499 88.9162 152.736 89.1425C152.973 89.368 153.103 89.6675 153.091 89.9581L152.101 114.716C152.085 115.121 151.754 115.447 151.299 115.506L111.615 120.635Z"
          fill="url(#paint23_linear)"
        />
        <path
          opacity="0.3"
          d="M111.615 120.635L151.299 115.505C151.752 115.446 152.084 115.12 152.1 114.715L152.389 107.501C141.524 112.338 126.648 112.371 111.601 114.104L111.615 120.635Z"
          fill="url(#paint24_linear)"
        />
        <path
          d="M133.041 124.785L131.629 125.212C131.629 125.212 124.292 122.977 123.885 122.852C123.821 122.833 123.449 122.609 123.668 122.527C124.914 122.061 132.321 121.631 132.321 121.631L137.705 122.184L133.041 124.785Z"
          fill="white"
        />
        <path
          d="M132.941 124.443L131.513 124.898C131.513 124.898 124.079 122.653 123.667 122.529C123.258 122.406 132.129 121.499 132.129 121.499L137.675 121.697L132.941 124.443Z"
          fill="url(#paint25_linear)"
        />
        <path
          d="M138.915 104.076C138.915 104.076 142.631 121.802 142.984 122.763C143.307 123.646 134.254 125.057 132.009 125.267C131.821 125.285 131.534 125.169 131.442 125.12C130.789 125.084 132.914 104.468 132.914 104.468L133.142 104.472L138.915 104.076Z"
          fill="white"
        />
        <path
          d="M138.838 104.076C138.838 104.076 142.994 122.465 143.339 123.451C143.681 124.432 132.984 125.289 132.031 125.265C131.411 125.199 133.11 104.48 133.11 104.48L138.838 104.076Z"
          fill="url(#paint26_linear)"
        />
        <path
          d="M83.6326 119.416C83.6326 119.416 84.5732 118.228 86.8069 118.075C89.0405 117.922 92.5944 119.406 93.2955 120.469C93.9975 121.532 93.3281 122.182 92.4253 122.135C91.5225 122.089 90.2815 120.848 88.5975 120.582C86.9126 120.316 83.5445 122.822 83.6326 119.416Z"
          fill="url(#paint27_linear)"
        />
        <path
          d="M220.069 71.6081C220.069 61.0257 210.308 52.764 198.681 53.1419C192.06 53.3568 186.3 56.3417 182.702 60.7482C182.702 60.7464 182.702 60.7456 182.701 60.7447C182.679 60.772 182.658 60.8002 182.636 60.8284C182.573 60.9059 182.513 60.9843 182.452 61.0618C182.341 61.2036 182.232 61.3471 182.125 61.4925C182.062 61.5779 182 61.6642 181.938 61.7514C181.835 61.8959 181.735 62.0421 181.637 62.1891C181.58 62.2737 181.524 62.3574 181.469 62.4428C181.36 62.6128 181.255 62.7854 181.151 62.9589C181.114 63.0215 181.075 63.0831 181.038 63.1465C180.901 63.3817 180.77 63.6195 180.645 63.8609C180.612 63.9252 180.582 63.9903 180.549 64.0546C180.457 64.2352 180.368 64.4166 180.284 64.6007C180.242 64.6905 180.203 64.7822 180.162 64.8729C180.091 65.0358 180.021 65.1988 179.954 65.3635C179.916 65.4595 179.878 65.5555 179.841 65.6515C179.776 65.8206 179.714 65.9914 179.655 66.1623C179.624 66.2522 179.592 66.3411 179.562 66.431C179.49 66.6467 179.425 66.8643 179.363 67.0827C179.349 67.1285 179.334 67.1734 179.322 67.2192C179.249 67.4835 179.184 67.7495 179.124 68.0172C179.106 68.0965 179.091 68.1758 179.075 68.255C179.035 68.447 178.997 68.6399 178.964 68.8346C178.947 68.9332 178.932 69.0328 178.916 69.1323C178.889 69.312 178.863 69.4925 178.842 69.674C178.83 69.7761 178.818 69.8774 178.808 69.9796C178.788 70.1707 178.773 70.3636 178.76 70.5565C178.754 70.6463 178.747 70.7353 178.742 70.826C178.728 71.1079 178.719 71.3915 178.719 71.676C178.719 78.4667 182.832 84.4568 188.997 87.6646C189.565 87.9597 190.149 88.231 190.75 88.4785C191.051 88.6018 191.356 88.7198 191.664 88.8308C193.835 89.6102 196.198 90.0726 198.681 90.1449C199.024 90.1546 199.364 90.1563 199.703 90.1519C199.818 90.1502 199.93 90.144 200.045 90.1405C200.269 90.1343 200.493 90.1273 200.716 90.114C200.852 90.1061 200.986 90.0938 201.122 90.0832C201.321 90.0682 201.519 90.0533 201.717 90.033C201.861 90.018 202.005 89.9995 202.148 89.9828C202.335 89.9599 202.521 89.937 202.707 89.9097C202.855 89.8886 203.001 89.8639 203.148 89.8392C203.327 89.8093 203.505 89.7785 203.683 89.745C203.832 89.7168 203.98 89.6869 204.127 89.6552C204.301 89.6182 204.474 89.5794 204.646 89.5389C204.794 89.5037 204.941 89.4684 205.087 89.4306C205.257 89.3865 205.426 89.3399 205.595 89.2923C205.74 89.2509 205.884 89.2104 206.028 89.1663C206.081 89.1505 206.135 89.1364 206.188 89.1197C206.187 89.1188 206.186 89.117 206.185 89.1161C214.227 86.5971 220.069 79.7667 220.069 71.6081Z"
          fill="url(#paint28_linear)"
        />
        <path
          d="M218.471 71.6112C218.471 82.1664 208.76 90.4395 197.191 90.1012C186.054 89.7762 177.325 81.5331 177.325 71.679C177.325 61.8249 186.054 53.5527 197.191 53.1907C208.759 52.8146 218.471 61.056 218.471 71.6112Z"
          fill="url(#paint29_linear)"
        />
        <path
          d="M195.86 60.765L192.744 66.4988L186.456 67.2536C185.549 67.3629 185.12 68.4938 185.73 69.172L189.976 73.8956L188.528 80.3965C188.315 81.3522 189.242 82.144 190.099 81.7327L196.015 78.8939L201.757 82.3792C202.61 82.8962 203.659 82.1951 203.528 81.1936L202.649 74.4161L207.623 69.8854C208.351 69.2222 207.999 68.019 207.032 67.8508L200.502 66.712L197.884 60.8011C197.509 59.9485 196.314 59.9309 195.86 60.765Z"
          fill="white"
        />
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M202.222 85.5076C199.712 79.9807 202.249 74.874 198.86 71.3289C195.456 67.7688 191.089 71.0964 186.46 68.2471C184.689 67.1575 182.734 65.0728 181.289 60.7728C178.795 63.8335 177.324 67.6076 177.324 71.6777C177.324 81.5318 186.053 89.7749 197.19 90.0999C199.802 90.1765 202.321 89.8119 204.658 89.0773C203.504 87.8751 202.742 86.6526 202.222 85.5076Z"
            fill="url(#paint30_linear)"
          />
        </g>
        <path
          d="M173.419 20.6977C180.207 20.9065 185.909 25.0505 187.019 30.2973C187.021 30.3043 187.022 30.3113 187.024 30.3175C187.084 30.6046 187.13 30.8953 187.162 31.1886C187.164 31.208 187.166 31.2274 187.168 31.2467C187.182 31.3841 187.193 31.5215 187.201 31.6598C187.203 31.6845 187.203 31.71 187.204 31.7356C187.211 31.8765 187.216 32.0183 187.216 32.161C187.216 38.2577 180.993 42.8782 173.418 42.4854C173.217 42.4748 173.017 42.4607 172.818 42.4431C172.798 42.4413 172.779 42.4405 172.759 42.4387C172.57 42.422 172.383 42.4008 172.197 42.3779C172.168 42.3744 172.139 42.3709 172.11 42.3674C171.929 42.3445 171.75 42.318 171.572 42.2899C171.539 42.2846 171.505 42.2793 171.472 42.2731C171.298 42.2441 171.123 42.2123 170.95 42.178C170.915 42.1709 170.881 42.1639 170.846 42.1569C170.674 42.1216 170.503 42.0846 170.334 42.0441C170.301 42.0362 170.269 42.0283 170.236 42.0203C170.068 41.9789 169.901 41.9367 169.736 41.8909C169.706 41.8829 169.677 41.8741 169.647 41.8653C169.498 41.823 169.35 41.779 169.204 41.7323C169.167 41.7209 169.129 41.7094 169.092 41.698C168.943 41.6504 168.796 41.5993 168.65 41.5474C168.618 41.5359 168.586 41.5262 168.555 41.5148L168.556 41.5139C163.52 39.6977 159.98 35.6101 159.98 31.0389C159.981 25.0989 165.955 20.4687 173.419 20.6977Z"
          fill="url(#paint31_linear)"
        />
        <path
          d="M158.544 31.0371C158.544 36.9753 164.517 42.0987 171.982 42.4845C179.557 42.8764 185.779 38.2568 185.779 32.1601C185.779 26.0634 179.557 20.9302 171.982 20.6977C164.517 20.4687 158.544 25.0989 158.544 31.0371Z"
          fill="url(#paint32_linear)"
        />
        <path
          d="M167.136 29.169C167.136 30.913 169.166 35.0596 170.6 37.7715C171.197 38.9016 172.771 38.9773 173.37 37.9028C174.815 35.3124 176.875 31.3102 176.875 29.5495C176.875 26.8332 174.679 24.5564 171.983 24.4639C169.3 24.3723 167.136 26.4791 167.136 29.169ZM169.375 29.2571C169.375 27.8091 170.541 26.6782 171.983 26.731C173.429 26.7839 174.604 28.0064 174.604 29.4614C174.604 30.9165 173.429 32.0474 171.983 31.9866C170.541 31.9267 169.375 30.7051 169.375 29.2571Z"
          fill="white"
        />
        <g opacity="0.3">
          <path
            opacity="0.3"
            d="M168.688 39.548C170.322 36.416 168.67 33.343 170.881 31.3612C173.137 29.339 176.083 31.4255 179.274 29.8243C180.512 29.2024 181.893 27.9711 182.921 25.3632C184.712 27.2815 185.779 29.6411 185.779 32.1601C185.779 38.2568 179.556 42.8773 171.982 42.4845C170.262 42.3955 168.622 42.0556 167.117 41.513C167.86 40.8692 168.351 40.1927 168.688 39.548Z"
            fill="url(#paint33_linear)"
          />
        </g>
        <path d="M102.799 62.5688L148.7 63.5517V54.6075L102.799 53.7839V62.5688Z" fill="url(#paint34_linear)" />
        <path d="M146.984 61.8801V56.2114L104.459 55.4222V60.9967L146.984 61.8801Z" fill="#2C2444" />
        <path
          d="M93.9902 62.3759L111.67 62.7546L105.453 49.9667L93.9902 49.7782V62.3759Z"
          fill="url(#paint35_linear)"
        />
        <path d="M109.033 61.0865L104.404 51.5574L95.6377 51.4077V60.8091L109.033 61.0865Z" fill="#2C2444" />
        <path d="M126.066 60.5941L129.109 60.6558V56.7319L126.066 56.6747V60.5941Z" fill="url(#paint36_linear)" />
        <path d="M121.955 60.5096L124.988 60.5721V56.6544L121.955 56.5972V60.5096Z" fill="url(#paint37_linear)" />
        <path d="M117.857 60.4259L120.88 60.4875V56.576L117.857 56.5197V60.4259Z" fill="url(#paint38_linear)" />
        <path d="M113.772 60.3422L116.786 60.4039V56.4994L113.772 56.4421V60.3422Z" fill="url(#paint39_linear)" />
        <path
          d="M84.6128 133.438C84.5626 133.398 84.4921 133.395 84.4375 133.43C81.9018 135.101 78.4923 133.821 77.0047 133.016C75.4395 132.167 70.6992 135.239 70.6992 135.239C70.6992 135.239 72.0028 142.238 72.1102 140.837C72.2177 139.436 75.2493 137.385 78.6544 139.457C81.5724 141.232 84.0191 135.332 84.6595 133.607C84.6832 133.547 84.6639 133.479 84.6128 133.438Z"
          fill="url(#paint40_linear)"
        />
        <path
          d="M74.2624 153.504C74.2994 153.724 74.1514 153.932 73.9321 153.97L73.8326 153.987C73.6124 154.024 73.4045 153.876 73.3666 153.656L70.2566 135.34C70.2197 135.12 70.3676 134.912 70.5869 134.874L70.6865 134.857C70.9066 134.82 71.1145 134.968 71.1524 135.188L74.2624 153.504Z"
          fill="#26264F"
        />
        <path
          d="M40.9188 121.551C40.792 122.026 40.5674 122.432 40.2072 122.677C40.1614 122.707 40.1138 122.728 40.0645 122.753C38.9556 123.307 38.6077 123.306 38.5196 125.699C38.5108 125.923 38.5046 126.163 38.5011 126.43C38.45 129.562 36.5317 126.986 36.5317 126.986C36.5317 126.986 36.4921 126.664 36.4533 126.158C36.3564 124.895 36.2534 122.477 36.7263 121.017C36.8805 120.541 37.0963 120.166 37.3896 119.966C37.8925 119.623 38.3892 119.369 38.8464 119.194C38.9186 119.166 38.9917 119.175 39.0613 119.151C39.2189 119.097 39.3731 119.057 39.5157 119.057H39.5193C40.7946 119.663 41.0404 120.684 40.9188 121.551Z"
          fill="url(#paint41_linear)"
        />
        <path
          d="M75.5973 156.997C74.7817 156.634 74.033 156.316 73.1963 155.939C72.3587 155.563 71.485 154.826 71.4691 153.831C71.4462 152.404 72.5181 149.151 74.2841 149.484C76.05 149.818 75.2291 152.139 74.5509 153.189C73.8727 154.239 75.0019 155.191 75.9919 155.612C75.8651 156.087 75.7259 156.531 75.5973 156.997Z"
          fill="url(#paint42_linear)"
        />
        <path
          d="M75.0797 154.781C74.9731 155.584 74.5143 156.26 74.4931 156.966C76.2459 159.712 81.5102 161.763 79.5928 166.309C76.8219 172.878 69.6982 174.719 60.0802 174.279C57.444 174.158 44.3813 172.257 41.0784 164.978C38.1762 158.584 41.1559 153.628 43.0654 145.905C44.5416 139.933 42.1529 131.48 39.5678 125.595C37.9499 125.688 36.6745 125.998 35.0785 126.674C37.6777 135.735 34.1167 140.447 29.8961 146.905C26.0057 152.859 24.5225 157.92 23.9394 162.365C23.2172 167.87 24.319 169.55 24.2098 173.815C24.1094 177.75 23.4638 186.527 23.0375 189.068C21.5402 197.995 19.695 213.31 22.3435 219.991C24.5753 225.62 25.1091 226.693 28.3442 228.623C34.8134 232.48 45.8751 227.367 53.802 227.966C56.5588 228.175 58.6991 230.426 62.556 227.578C64.8249 225.903 65.6607 215.204 64.9711 210.455C64.3819 206.398 61.9254 196.097 65.4546 191.92C68.5497 188.258 71.5073 188.904 77.4913 186.384C81.4054 184.736 91.056 177.722 92.091 171.903C92.8405 167.69 88.9211 161.546 88.2094 160.831C83.2189 155.824 80.6471 155.56 75.0797 154.781Z"
          fill="url(#paint43_linear)"
        />
        <path
          d="M50.3292 166.422C50.6145 165.486 49.5083 163.769 49.3409 163.555C48.6416 162.666 48.4672 162.469 47.8005 162.104C47.5741 161.981 47.4385 161.979 47.3231 161.937C47.2068 161.894 47.287 161.902 47.2447 161.914C46.7911 162.037 46.2274 161.782 45.8275 162.188C44.5495 163.484 45.6804 166.93 46.0222 168.483C46.0354 168.543 46.0081 168.777 46.038 168.899C46.068 169.021 45.9931 169.256 46.0451 169.396C46.2776 170.031 45.1264 170.438 45.0102 170.388C44.4121 170.13 41.9565 170.031 42.3538 170.793C43.2865 172.584 47.5829 173.567 48.6786 173.885C50.0341 174.28 55.5108 175.625 55.3258 174.189C55.2562 173.648 51.7463 172.311 50.729 172.008C50.5009 171.94 49.6492 171.319 49.5594 170.804C49.4369 170.107 48.9534 169.347 48.7596 168.622C49.5382 168.2 50.1187 167.112 50.3292 166.422Z"
          fill="url(#paint44_linear)"
        />
        <path
          d="M48.3378 160.667C48.4329 161.347 48.5712 162.573 48.0727 163.262C48.0084 163.351 47.8287 163.626 47.7829 163.777C47.7767 163.797 47.7512 163.875 47.7521 163.923C47.7662 164.544 48.809 165.079 48.7341 165.525C48.6593 165.971 47.9053 165.571 47.841 165.897C47.7767 166.224 48.4488 166.27 48.3933 166.563C48.3378 166.857 47.9273 166.724 47.775 167.007C47.6992 167.149 47.7071 167.437 47.6931 167.654C47.6851 167.776 47.6191 168.154 47.5697 168.265C47.3319 168.801 46.659 169.462 46.061 169.228C45.8945 169.162 46.002 169.009 45.8963 168.865C45.7906 168.72 45.7703 168.616 45.5677 168.421C45.2789 168.143 44.4712 167.849 44.1057 167.7C43.4292 167.426 42.8048 166.975 42.4472 166.503C42.3203 166.334 42.3565 166.363 42.3371 166.325C41.9487 165.574 41.651 164.464 41.9346 163.738C42.4093 162.52 43.8564 162.074 44.5416 161.141C45.3317 160.065 43.9665 157.928 45.152 157.39C46.3384 156.852 48.1607 159.407 48.3378 160.667Z"
          fill="#26264F"
        />
        <path
          d="M48.2886 165.389C47.99 165.178 47.5646 165.582 47.6879 166.014C47.8112 166.446 48.2894 166.922 48.7527 166.656C49.2169 166.39 48.6911 165.673 48.2886 165.389Z"
          fill="url(#paint45_linear)"
        />
        <path
          opacity="0.5"
          d="M40.024 215.236C44.7722 212.962 51.0284 218.817 52.944 216.439C55.1222 213.735 47.3837 204.518 48.1826 197.705C48.6485 193.731 52.4358 185.774 57.584 184.352C62.9505 182.87 67.4856 185.91 72.2259 183.31C74.7669 181.915 74.4402 179.426 76.7945 177.438C80.824 174.036 85.7405 174.713 89.4767 171.357C90.819 170.151 91.1881 167.167 91.0057 165.298C91.9702 167.163 92.0812 169.509 91.9631 171.565C91.5571 178.657 81.2054 184.382 77.4339 186.283C71.6684 189.19 68.5082 188.163 65.4316 191.883C61.9226 196.126 64.454 206.455 64.9816 210.466C65.5999 215.159 64.845 225.882 62.5647 227.591C58.6884 230.497 56.5508 228.032 53.8072 227.966C45.919 227.778 34.7156 231.761 28.3916 228.918C27.2871 228.421 26.5535 227.481 25.752 226.617C27.9539 226.762 31.3942 225.784 32.7576 224.494C35.9099 221.516 36.4137 216.965 40.024 215.236Z"
          fill="white"
        />
        <path
          d="M208.056 123.55L205.705 121.473C205.25 121.071 205.001 120.487 205.023 119.88C205.055 118.995 205.004 117.7 204.507 117.021C203.705 115.926 200.693 116.817 200.557 117.021C199.965 117.91 199.753 119.446 201.539 120.014C203.324 120.582 203.782 121.523 203.782 121.523L206.606 125.512L208.056 123.55Z"
          fill="url(#paint46_linear)"
        />
        <path
          d="M174.38 157.713L177.029 156.596C177.029 156.596 179.016 155.805 179.016 154.294C179.016 152.129 177.287 149.002 175.871 149.307C174.455 149.613 174.378 152.123 175.6 153.501C176.822 154.879 173.959 156.186 173.959 156.186L174.38 157.713Z"
          fill="url(#paint47_linear)"
        />
        <path
          d="M174.938 155.324C175.191 156.123 175.444 156.921 175.698 157.72C173.868 159.121 168.835 163.304 169.438 167.79C170.31 174.275 182.396 177.215 190.051 177.2C192.149 177.195 205.778 177.168 212.178 167.39C217.801 158.8 214.319 148.076 211.446 139.23C209.226 132.391 206.158 127.25 203.942 124.015C205.21 122.938 206.479 121.861 207.747 120.783C212.347 123.569 220.93 129.707 226.473 140.73C231.583 150.893 231.877 160.766 231.823 164.517C231.755 169.164 231.066 170.441 230.952 177.163C230.845 183.368 231.347 187.231 232.112 194.448C234.799 219.807 234.141 224.349 232.173 228.863C230.514 232.666 229.086 235.943 225.612 237.911C218.664 241.848 212.848 235.279 197.706 236.488C192.44 236.909 190.573 237.909 188.412 236.394C187.14 235.502 184.802 233.066 185.562 217.261C186.211 203.757 188.175 200.173 185.359 196.296C182.889 192.896 180.35 194.237 172.739 190.393C167.761 187.878 157.003 182.445 156.048 173.499C155.357 167.02 160.15 161.917 160.933 161.082C166.425 155.234 173.757 155.295 174.938 155.324Z"
          fill="url(#paint48_linear)"
        />
        <path
          d="M202.152 168.494C202.063 166.808 203.17 165.514 203.412 165.236C204.428 164.072 204.651 163.932 205.046 163.78L205.589 163.593C205.589 163.593 205.619 163.588 205.65 163.585C205.981 163.544 207.03 163.747 207.23 163.838C207.872 164.133 207.975 167.041 206.898 170.877C206.893 171.031 206.887 171.187 206.879 171.343C206.867 171.573 206.86 171.751 206.855 171.901C206.83 172.578 207.43 173.111 208.101 173.009C211.542 172.484 211.065 173.314 210.948 173.579C210.673 174.202 207.487 175.96 203.651 176.904C198.89 178.014 195.897 177.881 196.3 177.155C196.452 176.881 198.814 175.648 201.606 174.725C202.233 174.518 202.734 174.03 202.938 173.402C203.214 172.55 203.749 171.37 203.875 171.012C203.636 170.811 202.218 169.736 202.152 168.494Z"
          fill="url(#paint49_linear)"
        />
        <path
          d="M204.438 162.177C204.172 163.381 204.452 164.793 204.694 165.064C204.726 165.099 204.898 165.312 205.023 165.638C205.04 165.682 205.053 165.732 205.06 165.795C205.154 166.613 203.749 167.234 203.905 167.626C204.018 167.91 204.911 167.764 204.961 167.998C205.007 168.218 204.234 168.481 204.284 168.743C204.322 168.941 204.778 168.87 204.98 169.207C205.08 169.374 205.018 169.475 205.063 169.928C205.088 170.184 205.14 170.47 205.193 170.634C205.45 171.434 206.57 171.955 206.86 171.724C206.941 171.659 206.901 171.581 207.025 171.331C207.025 171.331 207.14 171.099 207.374 170.854C207.709 170.505 208.361 170.347 209.05 170.053C210.326 169.508 210.776 168.901 210.917 168.693C210.967 168.619 211 168.562 211.024 168.521C211.508 167.699 211.802 166.397 211.582 165.506C211.215 164.015 209.566 164.314 208.632 162.708C207.553 160.855 208.87 158.949 208.151 158.544C207.357 158.099 204.93 159.951 204.438 162.177Z"
          fill="#26264F"
        />
        <path
          d="M204.401 167.44C204.787 167.101 205.219 167.597 205.105 168.122C204.99 168.647 204.36 169.078 203.891 168.864C203.421 168.65 203.881 167.896 204.401 167.44Z"
          fill="url(#paint50_linear)"
        />
        <path
          opacity="0.2"
          d="M212.925 222.409C206.91 219.713 200.293 226.025 198.297 223.902C196.028 221.487 205.165 213.948 204.268 203.602C203.745 197.566 199.779 190.254 193.819 188.079C187.608 185.812 182.736 190.404 177.7 186.884C175 184.998 176.004 183.402 172.923 180.317C167.649 175.036 161.988 176.991 158.892 173.451C157.78 172.179 156.932 170.117 157.245 166.566C156.373 168.534 155.769 170.906 156.047 173.5C157.001 182.445 167.759 187.88 172.737 190.394C180.348 194.238 182.886 192.897 185.357 196.297C188.174 200.174 186.21 203.759 185.56 217.262C184.8 233.067 187.139 235.504 188.41 236.395C190.571 237.91 192.438 236.911 197.705 236.49C212.847 235.28 218.663 241.85 225.61 237.913C226.823 237.225 227.783 236.375 228.594 235.402C224.72 235.371 222.286 234.27 220.686 232.858C216.99 229.593 217.499 224.458 212.925 222.409Z"
          fill="url(#paint51_linear)"
        />
        <path
          d="M102.917 148.9C103.445 148.477 104.143 147.785 104.544 146.756C104.973 145.653 104.671 145.162 105.21 144.473C105.892 143.599 107.289 143.223 108.247 143.65C108.449 143.74 108.696 143.866 108.851 144.127C109.277 144.847 108.331 146.093 107.576 146.757C107.008 147.256 106.773 147.219 106.171 147.644C105.584 148.059 104.843 148.774 104.249 150.085L102.917 148.9Z"
          fill="url(#paint52_linear)"
        />
        <path
          d="M134.52 142.864C133.869 142.68 132.956 142.315 132.185 141.524C131.359 140.676 131.446 140.106 130.682 139.681C129.712 139.143 128.279 139.342 127.563 140.109C127.412 140.271 127.235 140.483 127.194 140.784C127.082 141.613 128.439 142.391 129.393 142.707C130.111 142.945 130.313 142.82 131.033 142.975C131.736 143.128 132.697 143.498 133.756 144.472L134.52 142.864Z"
          fill="url(#paint53_linear)"
        />
        <path
          d="M131.5 143.889C131.08 145.887 133.24 147.665 134.798 149.41C137.924 152.912 141.196 159.159 139.995 164.52C139.339 167.449 137.235 170.616 134.264 172.117C131.067 173.732 129.152 172.262 125.827 174.181C125.582 174.323 121.376 176.816 121.254 180.18C121.103 184.331 127.206 188.747 132.43 189.085C141.984 189.703 153.496 176.997 152.96 164.39C152.376 150.665 137.628 139.769 133.385 141.616C132.719 141.907 131.736 142.764 131.5 143.889Z"
          fill="url(#paint54_linear)"
        />
        <path
          d="M125.349 174.914C119.252 175.961 114.61 177.051 112.538 180.244C110.349 183.617 113.829 186.156 114.775 193.556C116.224 204.886 109.71 209.118 111.584 220.526C111.89 222.388 112.354 224.044 112.854 225.46C113.733 227.948 115.437 230.042 117.671 231.446C119.346 232.5 121.382 233.559 123.772 234.395C129.954 236.557 133.004 235.301 141.321 235.776C154.927 236.554 156.964 240.5 163.11 238.073C169.322 235.621 173.818 228.994 172.501 226.163C171.712 224.467 169.223 225.526 165.653 223.444C161.052 220.761 161.825 217.099 158.092 213.957C152.73 209.445 147.572 214.002 142.987 210.078C138.348 206.108 137.794 196.456 139.766 190.71C141.054 186.957 141.078 182.875 142.034 179.024C142.113 178.704 142.176 178.193 141.977 177.614C141.217 175.401 137.166 174.977 134.105 174.684C129.436 174.237 125.85 174.828 125.349 174.914Z"
          fill="url(#paint55_linear)"
        />
        <path
          opacity="0.3"
          d="M162.397 233.775C160.513 232.52 161.534 228.962 158.744 227.073C156.154 225.319 154.135 227.612 150.318 226.443C145.424 224.942 145.679 220.23 140.989 218.725C137.616 217.644 136.599 219.797 131.733 219.89C126.877 219.983 120.51 217.979 116.477 212.83C114.764 210.642 113.807 208.308 113.286 206.151C111.987 210.346 110.577 214.402 111.583 220.525C111.99 223.002 112.678 225.119 113.356 226.783C113.989 228.336 115.057 229.669 116.433 230.626C118.307 231.93 120.758 233.339 123.771 234.393C129.953 236.556 133.003 235.299 141.32 235.775C154.926 236.552 156.963 240.498 163.109 238.072C167.079 236.505 170.34 233.234 171.838 230.337C166.464 234.248 163.764 234.686 162.397 233.775Z"
          fill="url(#paint56_linear)"
        />
        <path
          d="M121.827 164.362C121.827 164.362 120.147 167.516 120.041 169.73C119.935 171.943 122.432 171.782 122.432 171.782L122.339 173.178C122.259 174.37 121.486 175.403 120.364 175.815L119.378 176.178C119.378 176.178 125.811 177.556 129.324 175.073L128.312 174.974C126.879 174.834 125.742 173.702 125.596 172.27L125.535 171.673C125.535 171.672 126.65 164.774 121.827 164.362Z"
          fill="url(#paint57_linear)"
        />
        <path
          d="M105.986 149.529C106.941 151.334 105.354 153.639 104.338 155.747C102.299 159.974 100.877 166.881 103.51 171.704C104.948 174.338 107.843 176.801 111.113 177.425C114.632 178.096 116.067 176.155 119.792 177.082C120.067 177.151 124.797 178.388 125.842 181.588C127.132 185.536 122.484 191.464 117.556 193.23C108.543 196.459 93.9731 187.421 91.011 175.154C87.7865 161.8 98.9582 147.26 103.546 147.866C104.268 147.961 105.45 148.513 105.986 149.529Z"
          fill="url(#paint58_linear)"
        />
        <path
          d="M122.832 167.499C123.165 167.472 123.439 167.05 123.667 167.175C123.906 167.306 123.88 167.921 123.673 168.352C123.503 168.706 123.224 168.905 123.07 168.999C123.327 169.354 123.654 169.906 123.79 170.629C124.091 172.228 123.241 173.514 122.888 174.267C121.295 177.659 123.773 183.022 126.494 185.73C128.704 187.931 129.736 187.046 131.056 188.844C132.277 190.508 130.953 197.595 131.408 200.9C132.228 206.862 140.404 210.8 145.291 212.049C146.726 212.416 156.896 214.842 163.884 208.223C167.778 204.535 169.747 198.954 169.487 194.91C169.406 193.654 169.025 188.885 165.14 184.994C164.524 184.376 160.871 180.726 155.936 180.682C153.322 180.658 152.795 181.58 150.796 181.01C148.059 180.23 146.374 177.742 145.327 176.199C143.404 173.36 144.186 172.754 142.801 171.357C140.089 168.622 136.908 170.77 134.011 168.356C131.156 165.976 132.878 162.748 130.123 160.688C127.279 158.563 121.841 159.305 120.682 161.835C119.686 164.007 121.813 167.582 122.832 167.499Z"
          fill="url(#paint59_linear)"
        />
        <path
          d="M45.957 102.802C45.8971 102.778 45.8284 102.795 45.787 102.844C43.8361 105.171 40.2038 104.923 38.5471 104.577C36.8049 104.213 33.1436 108.514 33.1436 108.514C33.1436 108.514 36.3989 114.846 36.1003 113.473C35.8017 112.1 38.1182 109.266 41.9742 110.275C45.2788 111.139 45.9315 104.786 46.0504 102.95C46.0548 102.885 46.0169 102.825 45.957 102.802Z"
          fill="url(#paint60_linear)"
        />
        <path
          d="M41.7915 124.993C41.8902 125.193 41.8083 125.435 41.6083 125.533L41.5176 125.578C41.3177 125.677 41.0755 125.595 40.9768 125.395L32.7469 108.738C32.6482 108.538 32.7301 108.296 32.9301 108.197L33.0208 108.152C33.2207 108.054 33.4629 108.136 33.5616 108.335L41.7915 124.993Z"
          fill="#26264F"
        />
        <path
          d="M40.9187 121.551C40.8404 122.144 40.592 122.596 40.3824 122.674C40.3251 122.696 40.267 122.687 40.2062 122.668C39.7341 122.514 39.1942 121.176 38.8278 120.065C38.8031 119.995 38.7855 119.929 38.7732 119.868C38.6948 119.535 38.7432 119.325 38.8463 119.195C38.8859 119.14 38.937 119.134 38.9916 119.106C39.2189 118.976 39.5157 119.057 39.5157 119.057H39.5192C40.7946 119.663 41.0403 120.684 40.9187 121.551Z"
          fill="url(#paint61_linear)"
        />
        <path
          d="M36.7279 121.013C36.6301 120.851 37.4263 118.815 38.2992 118.907C39.1711 119 39.3684 119.213 38.8858 119.701C38.4031 120.188 38.1671 123.386 36.7279 121.013Z"
          fill="url(#paint62_linear)"
        />
        <path
          d="M193.538 129.435C193.538 137.32 185.862 143.73 176.251 143.754C166.48 143.778 158.438 137.212 158.438 129.087C158.438 120.961 166.48 114.555 176.251 114.773C185.862 114.988 193.538 121.551 193.538 129.435Z"
          fill="url(#paint63_linear)"
        />
        <path
          d="M193.538 129.435C193.538 137.32 185.862 143.73 176.251 143.754C166.48 143.778 158.438 137.212 158.438 129.087C158.438 120.961 166.48 114.555 176.251 114.773C185.862 114.988 193.538 121.551 193.538 129.435Z"
          fill="url(#paint64_linear)"
        />
        <path
          d="M183.656 141.532C185.019 141.996 186.397 142.479 187.79 142.981C189.816 143.712 191.795 144.454 193.724 145.206C193.695 143.951 193.471 141.591 192.104 139.061C191.058 137.127 189.753 135.847 188.865 135.107L183.656 141.532Z"
          fill="url(#paint65_linear)"
        />
        <path
          d="M194.773 128.124C194.773 136.009 187.097 142.419 177.486 142.443C167.715 142.466 159.673 135.9 159.673 127.775C159.673 119.65 167.715 113.243 177.486 113.462C187.097 113.677 194.773 120.24 194.773 128.124Z"
          fill="url(#paint66_linear)"
        />
        <path
          d="M194.773 128.124C194.773 136.009 187.097 142.419 177.486 142.443C167.715 142.466 159.673 135.9 159.673 127.775C159.673 119.65 167.715 113.243 177.486 113.462C187.097 113.677 194.773 120.24 194.773 128.124Z"
          fill="url(#paint67_linear)"
        />
        <path
          d="M184.892 140.22C186.428 140.989 188.023 141.756 189.678 142.512C191.05 143.14 192.399 143.733 193.724 144.293C193.676 142.938 193.464 141.054 192.749 138.924C191.984 136.648 190.927 134.93 190.1 133.796L184.892 140.22Z"
          fill="url(#paint68_linear)"
        />
        <path
          d="M187.279 124.18C186.546 122.148 184.721 120.686 182.578 120.651C179.772 120.605 177.487 123.022 177.487 126.051C177.487 123.022 175.193 120.53 172.351 120.484C170.162 120.449 168.285 121.873 167.528 123.917C164.642 131.249 177.487 138.14 177.487 138.14C177.487 138.14 190.056 131.428 187.279 124.18Z"
          fill="white"
        />
        <g opacity="0.2">
          <path
            opacity="0.2"
            d="M181.731 138.755C179.626 134.482 181.754 130.505 178.906 127.721C175.999 124.879 172.198 127.454 168.081 125.106C166.481 124.194 164.698 122.461 163.369 118.915C161.053 121.347 159.673 124.42 159.673 127.776C159.673 135.901 167.715 142.467 177.486 142.443C179.702 142.438 181.814 142.093 183.751 141.471C182.797 140.566 182.164 139.634 181.731 138.755Z"
            fill="url(#paint69_linear)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="25.5193"
            y1="89.4886"
            x2="170.53"
            y2="89.4886"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00359712" stop-color="#E38DDD" />
            <stop offset="1" stop-color="#9571F6" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="88.1771"
            y1="145.371"
            x2="104.133"
            y2="95.3741"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#A03976" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="87.5811"
            y1="145.18"
            x2="103.537"
            y2="95.184"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#A03976" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="111.265"
            y1="154.378"
            x2="201.969"
            y2="154.378"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.494" stop-color="#EBEFF2" />
            <stop offset="1" stop-color="white" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="74.9908"
            y1="131.291"
            x2="88.3901"
            y2="89.306"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#A03976" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="97.1434"
            y1="85.5265"
            x2="107.781"
            y2="85.5265"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint6_linear"
            x1="112.794"
            y1="78.0068"
            x2="111.839"
            y2="80.1995"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint7_linear"
            x1="110.964"
            y1="81.5448"
            x2="112.481"
            y2="75.6573"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint8_linear"
            x1="112.418"
            y1="78.9478"
            x2="112.804"
            y2="78.582"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#444B8C" />
            <stop offset="0.9964" stop-color="#3E4177" />
          </linearGradient>
          <linearGradient
            id="paint9_linear"
            x1="112.529"
            y1="77.4306"
            x2="111.502"
            y2="79.3086"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint10_linear"
            x1="110.24"
            y1="80.2802"
            x2="111.884"
            y2="79.946"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00359712" stop-color="#6165D7" />
            <stop offset="1" stop-color="#AA80F9" />
          </linearGradient>
          <linearGradient
            id="paint11_linear"
            x1="110.578"
            y1="90.6433"
            x2="104.796"
            y2="75.9583"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#6B3976" />
          </linearGradient>
          <linearGradient
            id="paint12_linear"
            x1="107.37"
            y1="80.4851"
            x2="108.67"
            y2="101.112"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint13_linear"
            x1="107.091"
            y1="80.4817"
            x2="108.831"
            y2="74.3282"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint14_linear"
            x1="107.478"
            y1="73.0252"
            x2="107.25"
            y2="75.1163"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint15_linear"
            x1="107.478"
            y1="73.0153"
            x2="107.249"
            y2="75.1115"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint16_linear"
            x1="102.988"
            y1="81.7029"
            x2="106.044"
            y2="81.0814"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint17_linear"
            x1="103.393"
            y1="82.1854"
            x2="101.23"
            y2="84.1116"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint18_linear"
            x1="101.54"
            y1="81.9974"
            x2="104.9"
            y2="81.3141"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint19_linear"
            x1="101.531"
            y1="81.9543"
            x2="103.551"
            y2="81.5434"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint20_linear"
            x1="87.675"
            y1="121.602"
            x2="131.295"
            y2="121.602"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint21_linear"
            x1="87.675"
            y1="120.255"
            x2="131.317"
            y2="120.255"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#40447E" />
            <stop offset="0.9964" stop-color="#3C3B6B" />
          </linearGradient>
          <linearGradient
            id="paint22_linear"
            x1="152.688"
            y1="104.437"
            x2="110.444"
            y2="104.437"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint23_linear"
            x1="120.793"
            y1="87.5628"
            x2="147.805"
            y2="128.61"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint24_linear"
            x1="152.389"
            y1="114.069"
            x2="111.601"
            y2="114.069"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint25_linear"
            x1="125.641"
            y1="119.095"
            x2="138.905"
            y2="127.053"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint26_linear"
            x1="133.347"
            y1="105.961"
            x2="141.439"
            y2="140.035"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint27_linear"
            x1="83.6312"
            y1="120.101"
            x2="93.5881"
            y2="120.101"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint28_linear"
            x1="171.95"
            y1="16.5521"
            x2="202.467"
            y2="77.7918"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint29_linear"
            x1="189.896"
            y1="56.7767"
            x2="219.537"
            y2="111.752"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint30_linear"
            x1="181.756"
            y1="60.4297"
            x2="210.551"
            y2="118.215"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint31_linear"
            x1="159.766"
            y1="28.3302"
            x2="180.377"
            y2="33.1991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint32_linear"
            x1="176.945"
            y1="22.734"
            x2="159.274"
            y2="55.5076"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.00359712" stop-color="#E38DDD" />
            <stop offset="1" stop-color="#9571F6" />
          </linearGradient>
          <linearGradient
            id="paint33_linear"
            x1="182.124"
            y1="24.8994"
            x2="164.808"
            y2="59.6489"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
          <linearGradient
            id="paint34_linear"
            x1="138.838"
            y1="44.8699"
            x2="89.7801"
            y2="96.5869"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint35_linear"
            x1="107.305"
            y1="51.5491"
            x2="85.1261"
            y2="74.9297"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint36_linear"
            x1="119.247"
            y1="50.6287"
            x2="139.656"
            y2="70.2885"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint37_linear"
            x1="117.253"
            y1="52.5924"
            x2="137.615"
            y2="72.2061"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint38_linear"
            x1="115.264"
            y1="54.5467"
            x2="135.578"
            y2="74.1148"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint39_linear"
            x1="113.276"
            y1="56.4919"
            x2="133.543"
            y2="76.0143"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint40_linear"
            x1="71.0835"
            y1="137.499"
            x2="84.942"
            y2="135.146"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint41_linear"
            x1="17.9159"
            y1="97.4807"
            x2="100.859"
            y2="201.833"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint42_linear"
            x1="93.0696"
            y1="129.805"
            x2="17.9423"
            y2="224.325"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint43_linear"
            x1="106.246"
            y1="273.833"
            x2="2.35685"
            y2="105.07"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
          <linearGradient
            id="paint44_linear"
            x1="49.1418"
            y1="168.564"
            x2="47.6738"
            y2="186.294"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint45_linear"
            x1="49.788"
            y1="169.64"
            x2="56.2827"
            y2="185.065"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint46_linear"
            x1="187.421"
            y1="120.367"
            x2="325.504"
            y2="125.37"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#893976" />
            <stop offset="1" stop-color="#311944" />
          </linearGradient>
          <linearGradient
            id="paint47_linear"
            x1="186.206"
            y1="153.897"
            x2="324.289"
            y2="158.9"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#893976" />
            <stop offset="1" stop-color="#311944" />
          </linearGradient>
          <linearGradient
            id="paint48_linear"
            x1="155.978"
            y1="179.984"
            x2="233.892"
            y2="179.984"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint49_linear"
            x1="185.62"
            y1="170.064"
            x2="323.703"
            y2="175.067"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#893976" />
            <stop offset="1" stop-color="#311944" />
          </linearGradient>
          <linearGradient
            id="paint50_linear"
            x1="185.715"
            y1="167.447"
            x2="323.798"
            y2="172.45"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#893976" />
            <stop offset="1" stop-color="#311944" />
          </linearGradient>
          <linearGradient
            id="paint51_linear"
            x1="155.978"
            y1="202.875"
            x2="228.594"
            y2="202.875"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#AA80F9" />
            <stop offset="0.9964" stop-color="#6165D7" />
          </linearGradient>
          <linearGradient
            id="paint52_linear"
            x1="105.691"
            y1="145.245"
            x2="107.269"
            y2="154.445"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint53_linear"
            x1="130.54"
            y1="140.581"
            x2="132.677"
            y2="149.667"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint54_linear"
            x1="80.8779"
            y1="221.94"
            x2="-125.262"
            y2="432.756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint55_linear"
            x1="74.2765"
            y1="172.586"
            x2="330.568"
            y2="318.374"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint56_linear"
            x1="106.701"
            y1="182.824"
            x2="146.202"
            y2="233.443"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
          <linearGradient
            id="paint57_linear"
            x1="120.501"
            y1="168.803"
            x2="127.351"
            y2="179.058"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint58_linear"
            x1="82.8534"
            y1="157.509"
            x2="339.145"
            y2="303.296"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint59_linear"
            x1="158.119"
            y1="211.884"
            x2="129.753"
            y2="156.445"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#444B8C" />
            <stop offset="0.9964" stop-color="#26264F" />
          </linearGradient>
          <linearGradient
            id="paint60_linear"
            x1="34.1593"
            y1="110.571"
            x2="46.7615"
            y2="104.343"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint61_linear"
            x1="38.7352"
            y1="120.859"
            x2="40.9465"
            y2="120.859"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint62_linear"
            x1="36.7193"
            y1="120.392"
            x2="39.1425"
            y2="120.392"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFC444" />
            <stop offset="0.9964" stop-color="#F36F56" />
          </linearGradient>
          <linearGradient
            id="paint63_linear"
            x1="169.501"
            y1="117.239"
            x2="193.465"
            y2="161.686"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint64_linear"
            x1="169.501"
            y1="117.239"
            x2="193.465"
            y2="161.686"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint65_linear"
            x1="166.793"
            y1="112.427"
            x2="203.878"
            y2="161.208"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#311944" />
            <stop offset="1" stop-color="#893976" />
          </linearGradient>
          <linearGradient
            id="paint66_linear"
            x1="170.736"
            y1="115.928"
            x2="194.701"
            y2="160.375"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
          <linearGradient
            id="paint67_linear"
            x1="170.736"
            y1="115.928"
            x2="194.701"
            y2="160.375"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
          <linearGradient
            id="paint68_linear"
            x1="168.637"
            y1="112.202"
            x2="204.266"
            y2="159.068"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
          <linearGradient
            id="paint69_linear"
            x1="164.096"
            y1="118.462"
            x2="187.675"
            y2="165.777"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF9085" />
            <stop offset="1" stop-color="#FB6FBB" />
          </linearGradient>
        </defs>
      </svg>

      <Title align="center">
        <h1>Success!</h1>
        <span class="title__label">You have successfully created an ad campaign</span>
      </Title>

      <div class="flex justify-center items-center mt-8 w-full">
        <Button kind="secondary" url="/dashboard" label="Go to campaigns" />

        <span class="mr-4 ml-4 paragraph">or</span>

        <Button kind="default" label="Create another" @clicked="newCampaign" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { Button } from "cavea-design-system";

export default {
  name: "CreateCampaignCompleted",

  metaInfo: {
    title: "Create Campaign Completed",
  },

  components: {
    Title: () => import("@/components/Title"),
    Button,
  },

  methods: {
    ...mapMutations(["resetNewCampaign"]),

    /**
     * @summary reset campaign state to clean model & goto new campaign
     */
    newCampaign() {
      this.$router.push("/create/campaign/settings");

      this.resetNewCampaign();
    },
  },
};
</script>
